import { render } from "./InputTextEditor.vue?vue&type=template&id=38513e82&scoped=true"
import script from "./InputTextEditor.vue?vue&type=script&lang=js"
export * from "./InputTextEditor.vue?vue&type=script&lang=js"

import "./InputTextEditor.vue?vue&type=style&index=0&id=38513e82&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38513e82"]])

export default __exports__